import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { auth, db } from '../../firebase';
import "../../App.css";
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    getDoc,
    doc,
    limit
} from 'firebase/firestore';
import moment from 'moment';

export default function Logindetails() {
    // Toast setup
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    // States
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [logindetails, setlogindetails] = useState([]);
    const [searchText, setsearchText] = useState("");

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    // Effects
    useEffect(() => {
        if (searchText === '') {
            fetchData1();
        } else {
            fetchData2();
        }
    }, [searchText]);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid();
        });
        return () => unsubscribe();
    }, [userData]);

    // Fetch property id (user check)
    const fetchPropid = async () => {
        if (userData && loadincount) {
            const docRef = doc(db, "users", userData.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                fetchData1();
                setloadincount(false);
            }
        }
    };

    // Fetch data (default)
    const fetchData1 = async () => {
        try {
            const q = query(
                collection(db, 'logindetails'),
                orderBy('createdTime', 'desc'),
                limit(200)
            );
            onSnapshot(q, (querySnapshot) => {
                setlogindetails(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
                setCurrentPage(1); // reset to first page
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    };

    // Filtered data
    const fetchData2 = async () => {
        try {
            const filteredData = logindetails.filter((item) =>
                item.data.username?.toUpperCase().includes(searchText.toUpperCase())
            );
            setlogindetails(filteredData);
            setCurrentPage(1); // reset pagination
        } catch (error) {
            console.error('Error filtering data:', error);
        }
    };

    // Pagination Logic
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = logindetails.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(logindetails.length / recordsPerPage);

    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const goToPrevPage = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button
                            className="btn btn-secondary"
                            style={{ float: "right", textTransform: "uppercase" }}
                        >
                            || Login Details ||
                        </button>
                        <br /><br /><br />

                        <div className="card card-primary card-outline ex1">
                            {/* Search */}
                            <div className="p-1">
                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4'
                                    placeholder='Type here......'
                                />
                            </div>

                            {/* Table */}
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>User Name</th>
                                            <th>Login Time</th>
                                            <th>Platform</th>
                                            <th>Screen Ratio</th>
                                            <th>User Agent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.map((item, index) => (
                                            <tr key={item.id}>
                                                <td width="80">{indexOfFirstRecord + index + 1}</td>
                                                <td>{item.data.username}</td>
                                                <td>
                                                    {item.data.createdTime?.toDate
                                                        ? moment(item.data.createdTime.toDate()).format("DD-MM-YYYY hh:mm A")
                                                        : ""}
                                                </td>
                                                <td>{item.data.systemDetails?.platform}</td>
                                                <td>
                                                    {item.data.systemDetails?.screenHeight} X {item.data.systemDetails?.screenWidth}
                                                </td>
                                                <td>{item.data.systemDetails?.userAgent}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="card-footer d-flex justify-content-between align-items-center">
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={goToPrevPage}
                                    disabled={currentPage === 1}
                                >
                                    Previous
                                </button>
                                <span>Page {currentPage} of {totalPages}</span>
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={goToNextPage}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
